/* import __COLOCATED_TEMPLATE__ from './class-group-sprint-results-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';

export default class ClassGroupResultsCardComponent extends Component
{
	@service store;
	@service() config

	@tracked classGroup = null;
	@tracked sprintFormat = 'sprint'; // 'sprint' or 'sprint50'

	@tracked quarterfinalsEvent = null;
	@tracked semifinalsEvent = null;
	@tracked finalsEvent = null;
	
	@tracked Q1ClassGroup;
	@tracked Q2ClassGroup;
	@tracked Q3ClassGroup;
	@tracked Q4ClassGroup;
	@tracked Q5ClassGroup;
	
	@tracked S1ClassGroup;
	@tracked S2ClassGroup;
	@tracked S3ClassGroup;

	@tracked FClassGroup;
	@tracked FBClassGroup;

	@tracked includeQualifiers = true;

	@action
	selectClassGroup(event)
	{
		var classGroupId = event.target.value;

		if(classGroupId == '-')
		{
			this.classGroup = null;
		}
		else
		{
			var that = this;
			this.store.findRecord('classGroup', classGroupId).then(function(foundClassGroup)
			{
				that.classGroup = foundClassGroup;
			});
		}
	}

	@action
	selectSprintFormat(event)
	{
		this.sprintFormat = event.target.value;
	}

	@action
	toggleIncludeQualifiers(event)
	{
		this.includeQualifiers = event.target.checked;
	}

	get isFis50Format()
	{
		return this.sprintFormat === 'sprint50';
	}

	get isU16Format()
	{
		return this.sprintFormat === 'sprintU16';
	}

	get isStandardFormat()
	{
		return this.sprintFormat === 'sprint';
	}
	
	@action
	async quarterfinalsEventChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.quarterfinalsEvent = null;
		}
		else
		{
			var event = await this.store.findRecord('Event', browserEvent.target.value);
			this.quarterfinalsEvent = event;
		}
	}
	
	@action
	async semifinalsEventChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.semifinalsEvent = null;
		}
		else
		{
			var event = await this.store.findRecord('Event', browserEvent.target.value);
			this.semifinalsEvent = event;
		}
	}
	
	@action
	async finalsEventChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.finalsEvent = null;
		}
		else
		{
			var event = await this.store.findRecord('Event', browserEvent.target.value);
			this.finalsEvent = event;
		}
	}
	
	@action
	async Q1ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q1ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q1ClassGroup = classGroup;
		}
	}
	
	@action
	async Q2ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q2ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q2ClassGroup = classGroup;
		}
	}
	
	@action
	async Q3ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q3ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q3ClassGroup = classGroup;
		}
	}
	
	@action
	async Q4ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q4ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q4ClassGroup = classGroup;
		}
	}
	
	@action
	async Q5ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q5ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q5ClassGroup = classGroup;
		}
	}
	
	@action
	async S1ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.S1ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.S1ClassGroup = classGroup;
		}
	}
	
	@action
	async S2ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.S2ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.S2ClassGroup = classGroup;
		}
	}

	@action
	async S3ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.S3ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.S3ClassGroup = classGroup;
		}
	}

	@action
	async FBClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.FBClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.FBClassGroup = classGroup;
		}
	}
	
	@action
	async FClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.FClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.FClassGroup = classGroup;
		}
	}
	
	@computed('config')
	get host() 
	{
		return this.config.get('resultsBackendProtocol')+"://"+this.config.get('resultsBackendHost')+":"+this.config.get('resultsBackendPort');
	}
	
	@computed('config')
	get namespace() 
	{
		return this.config.get('resultsBackendNamespace');
	}
	
	get classGroupResultsDisabled()
	{
		return this.classGroup == null ? "disabled" : "";
	}
	
	get resultsXMLLink()
	{
		// U16 format: only needs semifinals and finals (no quarterfinals)
		if(this.isU16Format)
		{
			if(!this.classGroup || !this.semifinalsEvent || !this.finalsEvent
				||!this.S1ClassGroup||!this.S2ClassGroup||!this.S3ClassGroup
				||!this.FClassGroup)
				return "";

			let url = `${this.host}${this.namespace}/events/${this.args.event.id}/results/classGroup/${this.classGroup.id}/sprintU16?semifinalsEvent=${this.semifinalsEvent.id}&finalsEvent=${this.finalsEvent.id}&S1=${this.S1ClassGroup.id}&S2=${this.S2ClassGroup.id}&S3=${this.S3ClassGroup.id}&F=${this.FClassGroup.id}`;
			url += `&includeQualifiers=${this.includeQualifiers}`;
			return url;
		}

		// Standard and FIS50 formats require quarterfinals
		if(!this.classGroup || !this.quarterfinalsEvent || !this.semifinalsEvent || !this.finalsEvent
			||!this.Q1ClassGroup||!this.Q2ClassGroup||!this.Q3ClassGroup||!this.Q4ClassGroup||!this.Q5ClassGroup
			||!this.S1ClassGroup||!this.S2ClassGroup
			||!this.FClassGroup)
			return "";

		// For standard sprint format, also require FB
		if(this.isStandardFormat && !this.FBClassGroup)
			return "";

		const endpoint = this.isFis50Format ? 'sprint50' : 'sprint';
		let url = `${this.host}${this.namespace}/events/${this.args.event.id}/results/classGroup/${this.classGroup.id}/${endpoint}?quarterfinalsEvent=${this.quarterfinalsEvent.id}&semifinalsEvent=${this.semifinalsEvent.id}&finalsEvent=${this.finalsEvent.id}&Q1=${this.Q1ClassGroup.id}&Q2=${this.Q2ClassGroup.id}&Q3=${this.Q3ClassGroup.id}&Q4=${this.Q4ClassGroup.id}&Q5=${this.Q5ClassGroup.id}&S1=${this.S1ClassGroup.id}&S2=${this.S2ClassGroup.id}&F=${this.FClassGroup.id}`;

		// Add FB parameter only for standard sprint format
		if(this.isStandardFormat)
		{
			url += `&FB=${this.FBClassGroup.id}`;
		}

		// Add includeQualifiers parameter
		url += `&includeQualifiers=${this.includeQualifiers}`;

		return url;
	}
}